export const CepNumberOutput = (str) => {
  const cep = str.trim().replace(/\D/g, '');

  if (cep.length > 8) return cep.slice(0, 8);

  return cep.replace(/(\d{2})(\d{3})(\d{3})/g, '$1.$2-$3');
};

export const ValidateCep = (str) => {
  const cep = str.trim().replace(/\D/g, '');

  return /^\d{8}$/.test(cep);
};
